class GatedContent extends HTMLElement {
  constructor() {
    super();
    this.coverage = this.dataset.coverage;
    this.gateId = this.generateGateId();
    this.section = this.parentElement;
    
    if (!this.isLocked()) {
      this.remove();
      return;
    }

    this.setupForm();
  }

  generateGateId() {
    const sectionId = this.dataset.gateId;
    return `gate_${sectionId}_${this.coverage}`;
  }

  isLocked() {
    return !localStorage.getItem(this.gateId);
  }

  unlockGate() {
    localStorage.setItem(this.gateId, 'unlocked');
    this.style.opacity = '0';
    setTimeout(() => {
      this.remove();
    }, 300);
  }

  remove() {
    console.log('remove section', this.section)
    this.section.style.display = 'none';
  }

  setupForm() {
    const form = this.querySelector('form');
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const input = form.querySelector('input');
      const errorMsg = form.querySelector('.error-message');
      
      if (input.value === window.gatedContent[this.gateId]) {
        this.unlockGate();
      } else {
        errorMsg.style.display = 'block';
      }
    });
  }
}

customElements.define('gated-content', GatedContent);
